// @core/api/endpoints/team/update_role_delegation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateRoleDelegationRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Update role delegation
 * Updates an existing role delegation with the provided data. Returns the updated resource.
 */
export async function UpdateRoleDelegation(
  team_id: string,
  delegation_id: string,
  data: UpdateRoleDelegationRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/delegations/:delegation_id`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':delegation_id', encodeURIComponent(delegation_id));
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
